var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-scroll"},[_c('Navs',{staticClass:"home-nav"}),_c('home'),_c('Foots',{staticClass:"foots"}),_c('div',{staticClass:"foot"})],1),_c('bottom-backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }